import * as api from "./ApiClient";

export enum ModuleAccess {
    HierarchyExtractManage = 213
}

export default class ModuleAuthHelper {  
    public static ModuleIdInAccess(moduleSecurityAccessList:api.Module[],id:number):boolean{
            if (moduleSecurityAccessList != null) {
                var moduleAccess = moduleSecurityAccessList.filter(m => m.id == id);
                if (moduleAccess.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return false;
    }

    public static isFromMaintanaceModule(module: api.Module){
        return module.category && module.category.toLocaleLowerCase().includes("maintenance/consolidation");
    }

    public static checkButtonType(moduleName:string):string{
        if(moduleName.toLowerCase().includes("update")){
            return "ConsolidationUpdate";
        }
        else if(moduleName.toLowerCase().includes("view")){
            return "ConsolidationView";
        }
        else if(moduleName.toLowerCase().includes("import")){
            return "ConsolidationImport";
        }
        else if(moduleName.toLowerCase().includes("export")){
            return "ConsolidationExport";
        }
        else{
            return "";
        }
    }
}